<template>
  <div class="order-details orderDetails" ref="container">
    <div class="receiveInfo">
      <p class="cusInfo">
        <!-- <img src="@assets/images/logo2.png" /> -->
        <span class="customer">{{ orderInfo.customer_name }}</span>
        <span class="customer ml-20">{{ orderInfo.customer_phone }}</span>
      </p>
      <p>
        <span>{{ orderInfo.consignee_name }}</span>
        <span class="ml-20">{{ orderInfo.consignee_phone }}</span>
      </p>
      <p class="address">
        <span>地址：</span>
        {{ orderInfo.consignee_address }}
      </p>
      <div class="line">
        <img src="@assets/images/line.jpg" />
      </div>
    </div>
    <div class="infoBox mt-10">
      <p class="pro-count padding20 bor-b">
        <span>spu数：{{ orderInfo.total_spu }}</span>
        <span>sku数：{{ orderInfo.total_sku }}</span>
        <span>商品数：{{ orderInfo.total_num }}</span>
      </p>
      <ul class="proList pad20">
        <li
          class="proItem"
          v-for="(pro, index) in orderInfo.detail"
          :key="index"
        >
          <van-row class="bor-b pro-info">
            <van-col class="baseInfo" span="24">
              <!-- <p class="bor-b"> -->
              <!-- <span>{{index/1+1}}</span> -->
              <!-- <a class="pro-name"><span>{{pro.product_name}}</span> <span>{{pro.colour}}</span></a> -->
              <!-- </p> -->
              <p class="font-size-14">
                <a class="font-gray">
                  单价：¥
                  <span>{{ pro.price * 1 }}</span>
                </a>
                <a class="font-gray">
                  数量(双)：
                  <span>{{ pro.number }}</span>
                </a>
                <a class="font-gray">
                  金额：¥
                  <span>{{ pro.total * 1 }}</span>
                </a>
              </p>
            </van-col>
          </van-row>
          <van-row class="size-info" v-for="item in pro.item" :key="item.sku">
            <van-col span="3">
              <p style="height: 0.8rem; line-height: 0.8rem" class="bor-c">
                <img :src="pro.image" object-fit="cover" alt />
              </p>
            </van-col>
            <van-col span="21">
              <van-row class="bor-b bg-gray">
                <van-col span="12">
                  <p class="pro-name">{{ pro.product_name }}</p>
                </van-col>
                <van-col span="4">
                  <p>下单数</p>
                </van-col>
                <van-col span="4">
                  <p>发货数</p>
                </van-col>
                <van-col span="4">
                  <p>未发数</p>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12" class="bg-gray">
                  <p>{{ item.suk }}</p>
                </van-col>
                <van-col span="4">
                  <p>{{ item.order_num }}</p>
                </van-col>
                <van-col span="4">
                  <p>{{ item.shipments_num }}</p>
                </van-col>
                <van-col span="4">
                  <p>{{ item.no_shipments_num }}</p>
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </li>
      </ul>
    </div>
    <div class="infoBox mt-10">
      <van-cell
        :border="false"
        title="订单编号："
        v-model="orderInfo.order_id"
      ></van-cell>
      <van-cell
        :border="false"
        title="订单日期："
        v-model="orderInfo.order_time"
      ></van-cell>
      <van-cell
        :border="false"
        title="用户确认状态："
        v-model="confirmStaus[orderInfo.is_confirm]"
      ></van-cell>
      <van-cell
        :border="false"
        title="订单状态："
        v-model="orderStatus[orderInfo.status]"
      ></van-cell>
      <van-cell
        :border="false"
        title="支付状态："
        v-model="payStatus[orderInfo.pay_status]"
      ></van-cell>
      <van-cell
        :border="false"
        title="客户备注："
        v-model="orderInfo.customer_mark"
      ></van-cell>
      <!-- <van-cell style="color: #969799" title="客户备注客户备注客户备注"></van-cell> -->
      <van-cell
        :border="false"
        title="物流公司："
        v-model="orderInfo.freight_name"
      ></van-cell>
      <van-cell
        title="物流备注："
        v-model="orderInfo.freight_remarks"
      ></van-cell>
    </div>
    <div class="infoBox mt-10">
      <van-cell
        :border="false"
        title="商品金额："
        v-model="orderInfo.total_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="物流费用："
        v-model="orderInfo.freight_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="优惠减免金额："
        v-model="orderInfo.discount_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="合计应付金额："
        v-model="shouldPay"
      ></van-cell>
    </div>
    <div class="infoBox mt-10">
      <van-cell
        :border="false"
        :title="'已支付金额：' + orderInfo.pay_price * 1"
        v-model="unPay"
      ></van-cell>
    </div>
    <div class="infoBox pay-box mt-10">
      <van-cell title="支付方式："></van-cell>
      <van-cell
        :border="false"
        title="余额支付金额："
        v-model="orderInfo.balance_pay_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="线下转账金额："
        v-model="orderInfo.offline_pay_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="物流代收金额："
        v-model="orderInfo.freight_pay_price"
      ></van-cell>
      <van-cell
        :border="false"
        title="在线支付金额："
        v-model="orderInfo.on_line_pay_price"
      ></van-cell>
    </div>
    <div style="height:1.2rem;"></div>
    <div
      v-if="
        orderInfo.on_line_pay_price * 1 > 0 &&
          orderInfo.on_line_pay_status / 1 === 0
      "
      class="footer acea-row row-right row-middle"
    >
      <template>
        <div class="bnt bg-color-red" @click="pay = true">支付</div>
      </template>
    </div>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
  </div>
</template>
<script>
import Payment from "@components/Payment";
import { getOrderDetal } from "@api/order";
import { isWeixin, formatPrice } from "@utils";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      sizeList: [{}],
      shouldPay: 0,
      unPay: "未支付金额：0.00",
      orderInfo: {
        add_time: "",
        consignee_address: null,
        consignee_name: null,
        consignee_phone: null,
        customer_id: "5",
        customer_mark: null,
        customer_name: "",
        customer_phone: "",
        detail: [{ item: [{}] }],
        discount_price: "0.00",
        freight_name: "",
        freight_pay_price: null,
        freight_price: "0.00",
        freight_remarks: "",
        id: "",
        is_confirm: "0",
        offline_pay_price: "0.00",
        on_line_pay_price: "0.00",
        order_id: "",
        order_time: "",
        pay_status: "0",
        pay_time: null,
        pay_type: "0",
        status: "0",
        total_num: "0",
        pay_price: "0.00",
        total_price: "0.00",
        total_sku: "0",
        total_spu: "0"
      },
      confirmStaus: {
        1: "已确认",
        0: "未确认"
      },
      payType: {
        0: "余额支付",
        1: "线上支付",
        2: "线下支付",
        3: "物流代收"
      },
      payStatus: {
        0: "未支付",
        1: "部分支付",
        2: "已支付"
      },
      orderStatus: {
        0: "待支付",
        1: "已支付",
        2: "已发货",
        3: "完成",
        4: "关闭"
      },
      pay: false,
      payType: ["weixin", "yue"],
      orderId: "",
      isShow: 1
    };
  },
  created() {
    // console.log(this.$route)
    if (this.$route.query && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
      this.isShow = this.$route.query.isShow;
      this.getOrderDetal();
    }
    // this.getOrderDetal();
  },
  methods: {
    getOrderDetal() {
      const { orderId, isShow } = this;
      getOrderDetal({ orderId, isShow })
        .then(res => {
          formatPrice(res.data);
          this.shouldPay = (
            res.data.total_price / 1 +
            res.data.freight_price / 1 -
            res.data.discount_price / 1
          ).toFixed(2);
          this.unPay =
            "未支付金额：" +
            (this.shouldPay - res.data.pay_price / 1).toFixed(2);
          this.orderInfo = res.data;
          this.orderInfo.order_time = this.formdate(res.data.order_time);
          console.log(this.orderInfo);
        })
        .catch(e => {
          console.log(e);
          this.$dialog.toast({ mes: e.msg });
        });
    },
    formdate(date) {
      var unixTimestamp = new Date(date * 1000);
      var commonTime = unixTimestamp.toLocaleString();
      var s = commonTime.toLocaleString();
      var ss = s.replace(/年|月/g, "-").replace(/日/g, " ");
      return ss;
    },
    goBill() {
      this.$router.push({
        name: "dispatchBill"
      });
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  components: {
    Payment
  }
};
</script>
<style>
.pay-box .van-cell {
  padding: 3px 16px;
}
</style>
